import React from 'react';
import { Spacer } from '@zapier/design-system';
import List from '@zapier/product-get-help/esm/components/shared/List';
import RadioInput from '@zapier/product-get-help/esm/components/shared/RadioInput';
import Surface from '@zapier/product-get-help/esm/components/shared/Surface';
const DEFAULT_ICON = 'navHelp';
/**
 * Renders a block with a list of items using the `RadioInput` component.
 */
const RadioBlock = ({ title, items: items, onClick, size = 'large', }) => {
    const defaultIcon = items.find(item => !!item.icon)
        ? DEFAULT_ICON
        : undefined;
    return (React.createElement(Surface, { size: size, title: title },
        React.createElement(Spacer, { height: 20 }),
        React.createElement(List, { gap: 5, itemRenderer: (item) => (React.createElement(RadioInput, { icon: item.icon || defaultIcon, label: item.label, onClick: () => onClick(item) })), items: items })));
};
export default RadioBlock;
